
export default {
  data() {
    return {
      routes: [],
    }
  },
  created() {
    this.routes = this.$router.options.routes
  },
}
